module.exports = __webpack_public_path__ + "img/Matthew Janney.5502cff8.png";